import { render, staticRenderFns } from "./thesisUpload.vue?vue&type=template&id=2efee6b4&scoped=true&"
import script from "./thesisUpload.vue?vue&type=script&lang=js&"
export * from "./thesisUpload.vue?vue&type=script&lang=js&"
import style0 from "./thesisUpload.vue?vue&type=style&index=0&id=2efee6b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efee6b4",
  null
  
)

export default component.exports